import { render, staticRenderFns } from "./energyRing.vue?vue&type=template&id=3458f00e&scoped=true"
import script from "./energyRing.vue?vue&type=script&lang=js"
export * from "./energyRing.vue?vue&type=script&lang=js"
import style0 from "./energyRing.vue?vue&type=style&index=0&id=3458f00e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3458f00e",
  null
  
)

export default component.exports